import { render, staticRenderFns } from "./DefaultAvatar.vue?vue&type=template&id=27e0342a&scoped=true"
import script from "./DefaultAvatar.vue?vue&type=script&lang=js"
export * from "./DefaultAvatar.vue?vue&type=script&lang=js"
import style0 from "./DefaultAvatar.vue?vue&type=style&index=0&id=27e0342a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e0342a",
  null
  
)

export default component.exports